import Loader from 'components/commom/Loader';
import React, { useContext, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import moment from 'moment';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import DeleteList from 'assets/images/Dashboard/delete.svg';
import { patientsDetail } from 'routes/AppUrls';
import { ClearTokenRedirectLogin } from 'utils/general';
import { deletePatientData } from 'store/patientListDelete/patientListDeleteAction';
import {
  basicDetailsValue,
  PATIENT_ID,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonToast from 'components/commom/CommonToast';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';

function DashboardAppointmentList({ getUpdateValue }) {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const dashboardPatient = useSelector(
    (state) => state?.adminDashboardReducer?.users?.data
  );

  const loadingDelete = useSelector(
    (state) => state?.deletepatientListReducer?.loading
  );

  const loading = useSelector((state) => state?.adminDashboardReducer?.loading);

  const handlePatientDetail = (id) => {
    navigate(patientsDetail(locale));
    dispatch(basicDetailsValue(PATIENT_ID, id));
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteId('');
  };

  const deletePatientListData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseDeleteModal();
        getUpdateValue(true);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
        getUpdateValue(false);
      },
    };
    dispatch(deletePatientData(external, deleteId));
  };

  return (
    <div className="pt-16">
      {loading ? (
        <Loader />
      ) : dashboardPatient?.patient_list &&
        dashboardPatient?.patient_list.length > 0 ? (
        <>
          <Row className="listCustomHeader m-0 p-0 flex items-center">
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Patient & ID" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Contact Info" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Joined On" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Actions" />
              </p>
            </Col>
          </Row>
          <Row className="bc-FFFFFF m-0 p-0">
            {dashboardPatient?.patient_list.map((item, index) => {
              return (
                <Row className="m-0 p-0 flex items-center listAppointment">
                  <Col lg={3} md={6} sm={12}>
                    <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                      {item?.patient_name}
                    </div>
                    <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                      {item?.patient_id}
                    </div>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center "
                    >
                      <img src={mail} alt="icon" />
                      <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                        {item?.patient_email}
                      </div>
                    </Stack>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center pt-04"
                    >
                      <img src={call} alt="icon" />
                      <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                        {item?.patient_phone}
                      </div>
                    </Stack>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                      {moment(item?.date_joined).format('DD MMM YYYY')}
                    </div>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      className="items-center"
                    >
                      <div
                        className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4 cursor-pointer"
                        onClick={() => handlePatientDetail(item?.id)}
                      >
                        <FormattedMessage id="View Details" />
                      </div>
                      <img
                        src={ArrowRightIcon}
                        alt="icon"
                        onClick={() => handlePatientDetail(item?.id)}
                        className="cursor-pointer"
                      />
                      <div className="pl-28">
                        <Image
                          src={DeleteList}
                          alt="icon"
                          onClick={() => handleDeleteModal(item?.id)}
                          className="cursor-pointer"
                        />
                      </div>
                    </Stack>
                  </Col>
                </Row>
              );
            })}
          </Row>
        </>
      ) : (
        <div className="flex justify-center pt-40">
          <div>
            <Image src={EmptyScreen} alt="icon" />
            <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
              Nothing here yet
            </div>
          </div>
        </div>
      )}

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !loadingDelete && deletePatientListData();
                    }}
                    loading={loadingDelete}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
}

export default DashboardAppointmentList;
